import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Topluluk.css";

const Topluluk = () => {
  const [formData, setFormData] = useState({
    ad: "",
    email: "",
    telefon: "",
    mesaj: "",
    rol: "",
    digerRol: "",
    kvkkOnay: false,
    iletisimOnay: false,
  });
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData({ ...formData, [name]: checked });
    } else if (name === "rol" && value !== "Diğer") {
      setFormData({ ...formData, rol: value, digerRol: "" });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.kvkkOnay) {
      toast.error("KVKK aydınlatma metnini onaylamanız gerekmektedir.");
      return;
    }

    if (!recaptchaToken) {
      toast.error("Lütfen reCAPTCHA doğrulamasını yapın.");
      return;
    }

    const rol = formData.rol === "Diğer" ? formData.digerRol : formData.rol;

    try {
      const response = await fetch(
        `https://api.airtable.com/v0/${process.env.REACT_APP_AIRTABLE_BASE_ID}/${process.env.REACT_APP_AIRTABLE_TOPLULUK_TABLE_NAME}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_AIRTABLE_TOKEN}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            records: [
              {
                fields: {
                  "Ad Soyad": formData.ad,
                  "Email": formData.email,
                  "Telefon": formData.telefon,
                  "Rol": rol,
                  "Mesaj": formData.mesaj,
                  "Tarih": new Date().toISOString(),
                },
              },
            ],
          }),
        }
      );

      if (!response.ok) throw new Error("Sunucu hatası");
      toast.success("Başvurunuz alındı!");
      setFormData({ ad: "", email: "", telefon: "", mesaj: "", rol: "", digerRol: "", kvkkOnay: false, iletisimOnay: false });
      setRecaptchaToken(null);
      recaptchaRef.current?.reset();
    } catch (err) {
      console.error("Hata:", err);
      toast.error("Bir hata oluştu. Lütfen tekrar deneyin.");
    }
  };

  return (
    <div className="topluluk-page">
      {/* Hero Section */}
      <section className="topluluk-hero">
        <div className="topluluk-hero-overlay"></div>
        <div className="topluluk-hero-content">
          <div className="topluluk-hero-logo">
            <img
              src="/2.svg"
              alt="Brodmann 44 Logo"
              className="brodmann-logo-img"
            />
          </div>
          <p className="topluluk-hero-brand">BRODMANN 44</p>
          <h1 className="topluluk-title">
            <span>Afazi</span> Farkındalık Topluluğu
          </h1>
          <p className="topluluk-subtitle">
            İletişimin Gücüyle Yeniden Bağlanıyoruz
          </p>
          <p className="topluluk-hero-desc">
            Nörojenik dil bozuklukları yaşayan bireyler ve yakınları için
            bilimsel temelli destek ve sürdürülebilir sosyal çözümler
            geliştiriyoruz.
          </p>
          <div className="topluluk-hero-buttons">
            <button
              className="topluluk-hero-btn"
              onClick={() =>
                document
                  .getElementById("calismalarmiz")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
            >
              Çalışmalarımıza Göz At
            </button>
            <button
              className="topluluk-hero-btn topluluk-hero-btn-outline"
              onClick={() =>
                document
                  .getElementById("topluluk-form")
                  ?.scrollIntoView({ behavior: "smooth", block: "center" })
              }
            >
              Topluluğa Kaydol
            </button>
          </div>
        </div>
      </section>

      {/* Biz Kimiz */}
      <section className="topluluk-section">
        <div className="topluluk-container">
          <h2 className="section-title">
            Biz <span>Kimiz?</span>
          </h2>
          <p className="section-text">
            Brodmann 44; konuşma bozuklukları alanında farkındalık yaratmayı,
            bilgi paylaşımını artırmayı ve bu alandaki tüm bireyleri bir araya
            getirerek güçlü bir dayanışma ağı oluşturmayı hedefleyen bir
            topluluktur. Akademisyenlerden terapistlere, hastalardan hasta
            yakınlarına kadar geniş bir paydaş ağını kapsayarak konuşma
            bozukluklarının tedavisi ve destek mekanizmalarını geliştirmek için
            buradayız.
          </p>
        </div>
      </section>

      {/* Çalışmalarımız */}
      <section className="topluluk-section topluluk-section-alt" id="calismalarmiz">
        <div className="topluluk-container">
          <h2 className="section-title">
            Neler <span>Yapıyoruz?</span>
          </h2>
          <p className="section-text" style={{ marginBottom: "40px" }}>
            Topluluğumuzda teoriyi pratiğe, bilimsel bilgiyi ise sosyal faydaya
            dönüştürüyoruz.
          </p>
          <div className="calisma-grid">
            <div className="calisma-card">
              <div className="calisma-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" /></svg>
                <div className="calisma-bubble">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>
                </div>
              </div>
              <h3><span>Vaka</span> Sohbetleri</h3>
              <p>Uzman kadromuzla bir araya gelerek nörojenik dil bozuklukları üzerine derinlemesine incelemeler yapıyor, deneyim paylaşımı ve pratik çözümler üzerine odaklanıyoruz.</p>
            </div>
            <div className="calisma-card">
              <div className="calisma-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
              </div>
              <h3><span>Afazili</span> Grup Çalışmaları</h3>
              <p>Afazi yaşayan bireylerin sosyal izolasyonunu azaltmak ve iletişim becerilerini desteklemek amacıyla online ve yüz yüze destek grupları düzenliyoruz.</p>
            </div>
            <div className="calisma-card">
              <div className="calisma-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z" /><path d="M6 12v5c3 3 9 3 12 0v-5" /></svg>
              </div>
              <h3><span>Seminerler</span> & Konferanslar</h3>
              <p>Üniversiteler ve sağlık kuruluşları ile iş birliği yaparak toplumda farkındalık yaratacak bilimsel etkinlikler organize ediyoruz.</p>
            </div>
            <div className="calisma-card">
              <div className="calisma-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="18" x="3" y="3" rx="2" /><path d="M3 9h18" /><path d="M9 21V9" /></svg>
              </div>
              <h3><span>Kurumsal</span> İletişim Atölyeleri</h3>
              <p>Sağlık profesyonelleri ve kurumlar için afazili bireylerle etkili iletişim yöntemlerini içeren eğitimler ve atölyeler sunuyoruz.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Değerlerimiz */}
      <section className="topluluk-section">
        <div className="topluluk-container">
          <h2 className="section-title">
            Değer<span>lerimiz</span>
          </h2>
          <p className="section-text" style={{ marginBottom: "40px" }}>
            Bizimle yol yürüyen herkesin paylaştığı temel ilkeler:
          </p>
          <div className="degerler-grid">
            <div className="deger-card">
              <div className="deger-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#4D6B8A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9" /><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" /></svg>
              </div>
              <h3><span>Bilimsellik</span> & Doğru Bilgi</h3>
              <p>Çalışmalarımızı her zaman güncel ve bilimsel verilere dayandırırız.</p>
            </div>
            <div className="deger-card">
              <div className="deger-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#4D6B8A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" /></svg>
              </div>
              <h3><span>Empati</span> & Duyarlılık</h3>
              <p>Yaşadığınız güçlüklerin farkındayız, beraber neler yapabileceğimizi konuşmak istiyoruz.</p>
            </div>
            <div className="deger-card">
              <div className="deger-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#4D6B8A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="11" x="3" y="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
              </div>
              <h3><span>Şeffaflık</span> & Mahremiyet</h3>
              <p>Tüm süreçlerimizde güvene ve bireyin özel hayatına saygıya önem veririz.</p>
            </div>
            <div className="deger-card">
              <div className="deger-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#4D6B8A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" /><path d="M2 12h20" /></svg>
              </div>
              <h3><span>Kapsayıcılık</span></h3>
              <p>Ötekileştirme yapmadan, herkes için erişilebilir bilgi ve hizmet sunmayı amaçlarız.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Paydaşlarımız */}
      <section className="topluluk-section topluluk-section-alt">
        <div className="topluluk-container">
          <h2 className="section-title">
            <span>Paydaş</span>larımız
          </h2>
          <p className="section-text" style={{ marginBottom: "40px" }}>
            Brodmann 44 olarak multidisipliner bir yapıda çalışıyoruz.
          </p>
          <div className="paydas-grid">
            <div className="paydas-card">
              <div className="paydas-icon">
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#4D6B8A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
              </div>
              <h3><span>Hasta</span> Yakınları</h3>
              <p>Bilgilendirici içerikler ve psikolojik destek grupları</p>
            </div>
            <div className="paydas-card">
              <div className="paydas-icon">
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#4D6B8A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3" /><path d="M8 15v1a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6v-4" /><circle cx="20" cy="10" r="2" /></svg>
              </div>
              <h3><span>Sağlık</span> Profesyonelleri</h3>
              <p>Mesleki gelişim, eğitim ve multidisipliner iş birliği fırsatları</p>
            </div>
            <div className="paydas-card">
              <div className="paydas-icon">
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#4D6B8A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z" /><path d="M6 12v5c3 3 9 3 12 0v-5" /></svg>
              </div>
              <h3><span>Üniversite</span> Toplulukları</h3>
              <p>Öğrenciler için gönüllülük ve pratik deneyim imkanı</p>
            </div>
          </div>
        </div>
      </section>

      {/* Alıntı */}
      <section className="topluluk-section topluluk-quote-section">
        <div className="topluluk-container">
          <blockquote className="topluluk-quote">
            <p>"İletişim sadece kelimelerden ibaret değildir, bir dayanışma biçimidir."</p>
          </blockquote>
        </div>
      </section>

      {/* CTA - İki Sütun: Form + Bilgi */}
      <section className="topluluk-cta" id="topluluk-form">
        <div className="topluluk-container">
          <div className="cta-split">
            {/* Sol: Form */}
            <div className="cta-form-side">
              <h2 className="cta-form-title"><span>Topluluğumuza</span> Katılın</h2>
              <form className="cta-form" onSubmit={handleSubmit}>
                <div className="cta-form-group">
                  <input type="text" name="ad" placeholder="Ad Soyad" value={formData.ad} onChange={handleChange} required />
                </div>
                <div className="cta-form-group">
                  <input type="email" name="email" placeholder="E-posta" value={formData.email} onChange={handleChange} required />
                </div>
                <div className="cta-form-group">
                  <input type="tel" name="telefon" placeholder="Telefon Numarası" value={formData.telefon} onChange={handleChange} required />
                </div>
                <div className="cta-form-group">
                  <label className="cta-form-label">Size nasıl hitap edelim?</label>
                  <div className="cta-role-options">
                    {["Afazi Danışanı", "Doktor", "Afazi Bakım Veren", "Dil ve Konuşma Terapisti", "Öğrenci", "Diğer"].map((role) => (
                      <label key={role} className={`cta-role-option ${formData.rol === role ? "active" : ""}`}>
                        <input type="radio" name="rol" value={role} checked={formData.rol === role} onChange={handleChange} />
                        {role}
                      </label>
                    ))}
                  </div>
                  {formData.rol === "Diğer" && (
                    <input type="text" name="digerRol" placeholder="Lütfen belirtiniz..." value={formData.digerRol} onChange={handleChange} className="cta-diger-input" autoFocus />
                  )}
                </div>
                <div className="cta-form-group">
                  <textarea name="mesaj" placeholder="Mesajınız (isteğe bağlı)" value={formData.mesaj} onChange={handleChange} rows="3" />
                </div>
                <div className="cta-form-consents">
                  <label className="cta-consent-label">
                    <input type="checkbox" name="kvkkOnay" checked={formData.kvkkOnay} onChange={handleChange} />
                    <span><Link to="/kvkk" target="_blank">KVKK</Link>'yı ve <Link to="/aydinlatma-metni" target="_blank">Aydınlatma Metni</Link>'ni okudum ve anladım. <em>(Zorunlu)</em></span>
                  </label>
                  <label className="cta-consent-label">
                    <input type="checkbox" name="iletisimOnay" checked={formData.iletisimOnay} onChange={handleChange} />
                    <span>Lingify tarafından e-posta/SMS yoluyla ticari elektronik ileti gönderilmesini kabul ediyorum.</span>
                  </label>
                </div>
                <div className="cta-form-recaptcha">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                    onChange={(token) => setRecaptchaToken(token)}
                    onExpired={() => {
                      setRecaptchaToken(null);
                      toast.warning("reCAPTCHA süresi doldu, lütfen tekrar doğrulayın.");
                    }}
                    onErrored={() => {
                      setRecaptchaToken(null);
                      toast.error("reCAPTCHA yüklenemedi. Sayfayı yenileyin.");
                    }}
                  />
                </div>
                <button type="submit" className="cta-form-submit">Gönder</button>
              </form>
            </div>

            {/* Sağ: Bilgi */}
            <div className="cta-info-side">
              <h2 className="cta-info-title"><span>Birlikte</span> Daha Güçlüyüz</h2>
              <p className="cta-info-text">
                Brodmann 44 topluluğumuza katılarak etkinliklerden haberdar olun,
                vaka sohbetlerine katılın ve afazi farkındalığına katkıda bulunun.
              </p>
              <div className="cta-info-features">
                <div className="cta-info-feature">
                  <span className="cta-info-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
                  </span>
                  <span>Vaka sohbetlerine katılım</span>
                </div>
                <div className="cta-info-feature">
                  <span className="cta-info-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z" /><path d="M6 12v5c3 3 9 3 12 0v-5" /></svg>
                  </span>
                  <span>Seminer ve konferans duyuruları</span>
                </div>
                <div className="cta-info-feature">
                  <span className="cta-info-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" /></svg>
                  </span>
                  <span>Destek grupları ve paylaşımlar</span>
                </div>
              </div>
              <div className="cta-social-buttons">
                <a href="https://www.linkedin.com/company/brodmann44" target="_blank" rel="noopener noreferrer" className="cta-social-btn cta-linkedin-btn">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
                  LinkedIn'de Takip Et
                </a>
                <a href="https://chat.whatsapp.com/JUGBQFg5wYz3NhQ6x1SXGT" target="_blank" rel="noopener noreferrer" className="cta-social-btn cta-whatsapp-btn">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                  WhatsApp Topluluğu
                </a>
                <a href="https://www.instagram.com/brodmann_44" target="_blank" rel="noopener noreferrer" className="cta-social-btn cta-instagram-btn">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
                  Instagram'da Takip Et
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ToastContainer position="bottom-center" autoClose={3000} />
    </div>
  );
};

export default Topluluk;